import React, { Component } from "react";

import { fetchResorts, authenticate } from "./services/api";

import {
  MountainIcon,
  LoginIcon,
  PasswordIcon,
  OnIcon,
  DropDownIcon,
} from "./Icons";

import "./Authentification.css";

const mergeResorts = (resorts) => (prevState) => ({ resorts });

export default class Authentification extends Component {
  state = {
    resort: "",
    login: "",
    password: "",
  };

  componentDidMount() {
    fetchResorts().then((resorts) => {
      this.setState(mergeResorts(resorts));
    });
  }

  componentWillUnmount() {}

  fieldChanged = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  };

  submit = (e) => {
    e.preventDefault();

    const { authenticated } = this.props;
    const { resort, login, password } = this.state;
    authenticate(Number(resort), login, password).then((data) => {
      const { token } = data;
      if (token !== undefined) {
        authenticated(token);
      }
    });
  };

  renderAuthentificationForm() {
    const { resorts } = this.state;
    if (resorts !== undefined) {
      return [
        <div key="title" className="cm-authentification--welcome">
          Entrez votre authentification
        </div>,
        <form
          key="form"
          className="cm-authentification--form"
          onSubmit={this.submit}
        >
          <div className="cm-authentification--field cm-authentification--esf">
            <MountainIcon className="cm-authentification--icon" />
            <select
              name="resort"
              onChange={this.fieldChanged}
              value={this.state.resort}
              className="cm-authentification--select"
            >
              <option key={""} value={""}>
                Station...
              </option>
              {resorts.map((resort) => (
                <option key={resort.id} value={resort.id}>
                  {`ESF ${resort.name.toUpperCase()}`}
                </option>
              ))}
            </select>
            <DropDownIcon className="cm-authentification--dropdown" />
          </div>

          <div className="cm-authentification--field cm-authentification--login">
            <LoginIcon className="cm-authentification--icon" />
            <input
              type="text"
              name="login"
              placeholder="Login"
              value={this.state.login}
              onChange={this.fieldChanged}
            />
          </div>

          <div className="cm-authentification--field cm-authentification--password">
            <PasswordIcon className="cm-authentification--icon" />
            <input
              type="password"
              name="password"
              value={this.state.password}
              onChange={this.fieldChanged}
              placeholder="Mot de passe"
            />
            <button type="submit" className="cm-authentification--submit">
              <OnIcon className="cm-authentification--submit-icon" />
            </button>
          </div>
        </form>,
      ];
    }

    return (
      <div className="cm-error">
        <span className="cm-error--title">Erreur réseau</span>
        <span className="cm-error--detail">Récupération des stations</span>
      </div>
    );
  }

  render() {
    return (
      <div className="cm-authentification">
        <div className="cm-authentification--header">
          {/* <img
            src="/images/logo-clubmed.svg"
            alt="Club Med"
            className="cm-authentification--clubmed"
          /> */}
        </div>
        <div className="cm-authentification--body">
          <img
            src="/images/logo-esf.svg"
            alt="ESF"
            className="cm-authentification--logo"
          />
          {this.renderAuthentificationForm()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Authentification.js